<template>
  <div class="w-full px-5 lg:px-0" :class="[layout === 'column' ? 'is-column' : 'is-row']">
    <span class="flex items-center justify-center" :class="{ ' mb-4': layout === 'column' }">
      <slot name="icon" />
    </span>

    <div
      v-if="title || message"
      class="flex flex-col justify-center"
      :class="{ 'text-center lg:text-left': layout === 'row', 'text-center': layout === 'column' }"
    >
      <h1 v-if="title" class="text-3xl-1 lg:text-3xl capitalize font-medium">
        {{ title }}
      </h1>

      <p v-if="message" class="mt-4 text-system-gray text-sm" :class="[layout === 'column' ? 'max-w-xl' : 'max-w-sm']">
        {{ message }}
      </p>
    </div>

    <AppButton
      v-if="cta"
      as="AppLink"
      data-attr="emptyMessage__navigation"
      class="w-full justify-center"
      :class="{ 'mt-6 mx-auto lg:max-w-sm': layout === 'column', 'lg:justify-self-end lg:w-max': layout === 'row' }"
      :to="href"
      inverted
    >
      <span class="text-center uppercase">{{ cta }}</span>
    </AppButton>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  href: {
    type: String,
    required: true,
  },
  cta: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  buttonIcon: {
    type: String,
    default: '',
  },
  layout: {
    type: String,
    default: 'column',
    validator: (value: string) => ['column', 'row'].includes(value),
  },
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const iconToRender = computed(() => resolveComponent('svg-icon-' + props.icon));
</script>

<style lang="postcss" postcss>
.is-column {
  @apply flex flex-col items-center justify-center;
}

.is-row {
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  row-gap: 20px;

  @screen lg {
    grid-template-columns: 72px 1fr 280px;
    align-items: center;
    justify-items: flex-start;
    column-gap: 30px;
  }
}
</style>
